import type { ProductTreeActionsItem } from 'src/app/core/models/productTreeActions.model';
import type { Entity } from '../../../core/models/entity.model';

export interface ProjectDataState {
  projectEntities: Entity[];
  temporaryHoodlineEntities: Entity[];
  projectActions: ProductTreeActionsItem[];
  loading: boolean;
  latestCreatedId: string | null;
  latestCopiedId: string | null;
  latestCopiedEntityParentId: string | null;
  latestDeletedIdList: string[];
  actionInitialized: boolean;
  lastSelectedHoodId: string;
  lastSelectedModuleId: string;
  lastSelectedEntityId: string;
  projectLoaded: boolean;

  /**
   * Set to true if the last dispatched action ended up in an error.
   * For example, if a project creation fails, this is set to true.
   *
   * This value is set to false when a new action starts
   */
  latestActionCausedError: boolean;
}

export const initialState: ProjectDataState = {
  projectEntities: [],
  temporaryHoodlineEntities: [],
  projectActions: [],
  loading: false,
  latestCreatedId: null,
  latestCopiedId: null,
  latestCopiedEntityParentId: null,
  latestDeletedIdList: [],
  latestActionCausedError: false,
  actionInitialized: false,
  lastSelectedHoodId: null,
  lastSelectedModuleId: null,
  lastSelectedEntityId: null,
  projectLoaded: false
};
